if (!customElements.get('footer-redesign')) {
  class FooterRedesign extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.initialized = true;
      this.isDesktopView = window.innerWidth > 768;
      this.navColumns = [...this.querySelectorAll('[data-footer-redesign-nav]')];
      this.navToggles = [...this.querySelectorAll('[data-footer-redesign-nav-toggle]')];
      this.disclosureItems = [...this.querySelectorAll('[data-footer-redesign-disclosure-item]')];
      this.cleanupFns = [];

      this.navToggles.forEach((toggle) => {
        const onClick = this.handleNavToggle.bind(this);
        toggle.addEventListener('click', onClick);
        this.cleanupFns.push(() => toggle.removeEventListener('click', onClick));
      });

      this.disclosureItems.forEach((item) => {
        const toggle = item.querySelector('[data-footer-redesign-disclosure-toggle]');
        if (toggle) {
          const onToggleClick = this.handleDisclosureToggle.bind(this);
          toggle.addEventListener('click', onToggleClick);
          this.cleanupFns.push(() => toggle.removeEventListener('click', onToggleClick));
        }

        item.querySelectorAll('[data-footer-redesign-disclosure-option]').forEach((option) => {
          const onOptionClick = this.handleDisclosureOption.bind(this);
          option.addEventListener('click', onOptionClick);
          this.cleanupFns.push(() => option.removeEventListener('click', onOptionClick));
        });
      });

      this.onDocumentClick = this.handleDocumentClick.bind(this);
      this.onKeyUp = this.handleKeyUp.bind(this);
      this.onResize = this.handleResize.bind(this);

      document.addEventListener('click', this.onDocumentClick);
      this.addEventListener('keyup', this.onKeyUp);
      window.addEventListener('resize', this.onResize);
      this.syncNavState();
    }

    disconnectedCallback() {
      if (!this.initialized) return;

      this.cleanupFns.forEach((cleanup) => cleanup());
      this.cleanupFns = [];
      document.removeEventListener('click', this.onDocumentClick);
      this.removeEventListener('keyup', this.onKeyUp);
      window.removeEventListener('resize', this.onResize);
      this.initialized = false;
    }

    handleNavToggle(event) {
      if (this.isDesktopView) return;

      const toggle = event.currentTarget;
      const item = toggle.closest('[data-footer-redesign-nav]');
      if (!item) return;

      const expanded = item.getAttribute('data-expanded') === 'true';
      this.navColumns.forEach((column) => this.setNavExpanded(column, false));
      this.setNavExpanded(item, !expanded);
    }

    handleDisclosureToggle(event) {
      event.stopPropagation();

      const toggle = event.currentTarget;
      const item = toggle.closest('[data-footer-redesign-disclosure-item]');
      if (!item) return;

      const expanded = item.getAttribute('data-is-expanded') === 'true';
      this.closeDisclosures();

      item.setAttribute('data-is-expanded', expanded ? 'false' : 'true');
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      const panel = item.querySelector('.fr-footer__disclosure-list');
      if (panel) panel.setAttribute('aria-hidden', expanded ? 'true' : 'false');
    }

    handleDisclosureOption(event) {
      event.preventDefault();

      const option = event.currentTarget;
      const item = option.closest('[data-footer-redesign-disclosure-item]');
      if (!item) return;

      const input = item.querySelector('[data-footer-redesign-disclosure-input]');
      const form = option.closest('form');
      if (input) input.value = option.dataset.value || '';
      if (form) form.submit();
    }

    handleDocumentClick(event) {
      const target = event.target;
      if (!(target instanceof Element)) {
        this.closeDisclosures();
        return;
      }

      if (!this.contains(target) || !target.closest('[data-footer-redesign-disclosure-item]')) {
        this.closeDisclosures();
      }
    }

    handleKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.closeDisclosures();
    }

    handleResize() {
      const isDesktopView = window.innerWidth > 768;
      if (isDesktopView === this.isDesktopView) return;

      this.isDesktopView = isDesktopView;
      this.syncNavState();
    }

    syncNavState() {
      this.navColumns.forEach((column) => this.setNavExpanded(column, this.isDesktopView));
    }

    setNavExpanded(item, expanded) {
      item.setAttribute('data-expanded', expanded.toString());

      const toggle = item.querySelector('[data-footer-redesign-nav-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', expanded.toString());

      const panel = item.querySelector('.fr-footer__nav-links');
      if (panel) panel.setAttribute('aria-hidden', (!expanded).toString());
    }

    closeDisclosures() {
      this.disclosureItems.forEach((item) => {
        item.setAttribute('data-is-expanded', 'false');
        const toggle = item.querySelector('[data-footer-redesign-disclosure-toggle]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        const panel = item.querySelector('.fr-footer__disclosure-list');
        if (panel) panel.setAttribute('aria-hidden', 'true');
      });
    }
  }

  customElements.define('footer-redesign', FooterRedesign);
}
